import { loadModal } from '../../../AsyncLoader';


async function getUserConfirmation($trigger, { title, body, okButton, cancelButton }) {
  const Modal = await loadModal();

  return new Promise((resolve) => {
    const modal = Modal.confirm({
      title,
      bodyContents: body,
      labelBtnConfirm: okButton,
      labelBtnCancel: cancelButton,
      returnFocusTo: $trigger,
      closeOnConfirm: false,
      onConfirm: () => {
        const { formButtonHandler } = window.tnew.handlers;

        formButtonHandler.applyBusyStyling(modal.getButtonConfirm(), { disableElement: false });

        resolve(true);
      },
      onCancel: () => resolve(false),
    });
  });
}


export default getUserConfirmation;
